export default __webpack_public_path__ + "static/media/joinUs.8f3d994d.svg";